import Autorenew from '@mui/icons-material/Autorenew';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function AutorenewIcon(props: FixMe) {
  return <Autorenew {...props} />;
}

export default AutorenewIcon;
